import { $currentUser } from './model';

export enum Permissions {
  CreateEmployee = 'can_create_employee',
  CreateVacancy = 'create_vacancy',
  CloseVacancy = 'close_vacancy',
  ViewFeedbackProcesses = 'view_soft_skill_processes',
  CanCreateKarmaEvents = 'can_create_karma_events',
  CanUpdateSelfTeamInfo = 'can_update_self_team_info',
  CanUpdateAnyTeamInfo = 'can_update_any_team_info',
  GenerateLinkForExternalFeedback = 'generate_any_link_for_external_feedback',
  CanUpdateEmployeeAllProfile = 'can_update_employee_all_profile',
  CanUpdateEmployeePartProfile = 'can_update_employee_part_profile',
  CanUpdateAnyAdaptations = 'can_update_any_employee_adaptation_process',
  CanUpdateSelfAdaptations = 'can_update_managed_employee_adaptation_process',
  CanViewMentorAdaptationProcesses = 'can_view_mentor_adaptation_process',
  CanViewTeamPage = 'can_view_team_page',
  CanUpdateOccasions = 'can_update_occasion',
  CanCreatePinnedOccasion = 'can_create_pinned_occasion',
}

const knownPermissions = Object.values(Permissions);

export const $permissions = $currentUser.map((el) => {
  const result = knownPermissions.reduce((acc, cur) => {
    acc[cur] = false;

    return acc;
  }, {} as Record<Permissions, boolean>);

  el?.permissions?.forEach((el) => {
    if (result[el.code as Permissions] !== undefined) {
      result[el.code as Permissions] = true;
    }
  });

  //TODO: убрать когда поменяют свагер
  if (el?.roles && el?.roles.length > 0) {
    //@ts-ignore
    el?.roles.forEach((role) => {
      if (role?.permissions && role?.permissions.length > 0) {
        //@ts-ignore
        role?.permissions.forEach((permission) => {
          if (result[permission.code as Permissions] !== undefined) {
            result[permission.code as Permissions] = true;
          }
        });
      }
    });
  }
  //в настоящий момент на беке не могут подвязать пермишн на аттрибут
  if (el?.attributes?.some((attr) => attr?.code === 'MENTOR')) {
    result[Permissions.CanViewMentorAdaptationProcesses] = true;
  }

  return result;
});

export const $canCreateEmployee = $permissions.map((el) => el[Permissions.CreateEmployee]);

export const $canViewFeedbackProcesses = $permissions.map((el) => el[Permissions.ViewFeedbackProcesses]);

export const $canCreateVacancy = $permissions.map((el) => el[Permissions.CreateVacancy]);

export const $canCloseVacancy = $permissions.map((el) => el[Permissions.CloseVacancy]);

export const $canCreateKarmaEvents = $permissions.map((el) => el[Permissions.CanCreateKarmaEvents]);

export const $canUpdateSelfTeamInfo = $permissions.map((el) => el[Permissions.CanUpdateSelfTeamInfo]);

export const $canUpdateAnyTeamInfo = $permissions.map((el) => el[Permissions.CanUpdateAnyTeamInfo]);

export const $canGenerateLinkForExternalFeedback = $permissions.map((el) => el[Permissions.GenerateLinkForExternalFeedback]);

export const $canUpdateEmployeeAllProfile = $permissions.map((el) => el[Permissions.CanUpdateEmployeeAllProfile]);

export const $canUpdateEmployeePartProfile = $permissions.map((el) => el[Permissions.CanUpdateEmployeePartProfile]);

export const $canViewMentorAdaptationProcesses = $permissions.map((el) => el[Permissions.CanViewMentorAdaptationProcesses]);

export const $canUpdateAnyAdaptations = $permissions.map((el) => el[Permissions.CanUpdateAnyAdaptations]);

export const $canUpdateSelfAdaptations = $permissions.map((el) => el[Permissions.CanUpdateSelfAdaptations]);

export const $canViewTeamPage = $permissions.map((el) => el[Permissions.CanViewTeamPage]);

export const $canCreatePinnedOccasion = $permissions.map((el) => el[Permissions.CanCreatePinnedOccasion]);

export const $canUpdateOccasions = $permissions.map((el) => el[Permissions.CanUpdateOccasions]);
